import 'css-chunk:src/components/common/CreatorList/CampaignInviteButton.scss';export default {
  "CampaignInviteButton": "_CampaignInviteButton_1l3es_1"
};